module.exports = __webpack_public_path__ + "static/media/icon_relativeFinder_active.bc620bc4.svg";